export default "/images/bf88f978ee802d1ca83db599d1085ff8.avif";